import { CreateFloorPlanMemoTextParams, WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/texts/`;

export const createFloorPlanMemoText = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
  content,
  position,
  style,
}: WithBranchParams<CreateFloorPlanMemoTextParams>) => {
  const url = createApiUrl(branchUid, floorPlanId);
  const { data } = await axiosInstance.post(url, {
    content,
    style: {
      color: style.color,
      width: style.width,
      opacity: style.opacity,
      font_size: style.fontSize,
      has_stroke: style.hasStroke,
      ...(style.rotation != null && { rotation: style.rotation }),
    },
    position,
    version: branchVersionId,
  });

  return data;
};
